// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"373":"8d7c4922","766":"1874920a"}[chunkId] + ".js";
};